import { exeRequest } from '../utils/APIUtils'


const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get: async () => exeRequest(`/admin/users/historique-numeros`, "GET"),
    getList: async (params) => exeRequest(`/admin/users/historique-numeros${buildQuery(params)}`, "GET"),


    historiqueVehiculesModifies: async () => exeRequest(`/admin/historique-vehicules-modifies`, "GET"),
    historiqueVehiculesModifiesList: async (params) =>exeRequest(`/admin/historique-vehicules-modifies${buildQuery(params)}`, "GET"),

    // getById: async (id) => exeRequest(`/admin/partenaires/${id}`, "GET"),
    supprimerHistoriqueNumerosById: async (id) => exeRequest(`/admin/users/historique-numeros/${id}`, "DELETE"),
    supprimerHistoriqueVehiculesModifies: async (id) => exeRequest(`/admin/historique-vehicules-modifies/${id}`, "DELETE"),

}